module.exports = __webpack_public_path__ + "bdd7a057f64e0c1d3e4e7cad6a9a03cf.png";